// src/components/common/withSnackbarWrapper.js

import React from "react";
import useSnackbarCustom from "./useSnackbarCustom";

const withSnackbarWrapper = (WrappedComponent) => {
  return (props) => {
    const snackbar = useSnackbarCustom();
    return <WrappedComponent {...props} useSnackbarCustom={snackbar} />;
  };
};

export default withSnackbarWrapper;
